import React, { useEffect, useRef } from 'react';

const RECAPTCHA_API_URL = 'https://www.google.com/recaptcha/api.js?render=explicit';
let recaptchaApiPromise;

export const loadRecaptchaApi = () => {
  if (window.grecaptcha) return Promise.resolve(window.grecaptcha)
  if (recaptchaApiPromise) return recaptchaApiPromise

  recaptchaApiPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.id = 'recaptcha-api'
    script.src = RECAPTCHA_API_URL
    script.async = true
    script.defer = true
    script.onload = () => resolve(window.grecaptcha)
    script.onerror = (error) => { recaptchaApiPromise = null; reject(error) }
    document.head.appendChild(script)
  })

  return recaptchaApiPromise;
}

const Recaptcha = ({ onChange, siteKey }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    let mounted = true;

    loadRecaptchaApi().then((api) => {
      api.ready(() => {
        if (mounted && containerRef.current) {
          api.render(containerRef.current, {
            sitekey: siteKey,
            callback: onChange,
            'expired-callback': () => onChange(''),
            'error-callback': () => onChange('')
          });
        }
      })
    }).catch((error) => {
      console.error('Unable to load reCAPTCHA.', error);
    })

    return () => { mounted = false }
  }, [onChange, siteKey])

  return <div ref={containerRef} className='g-recaptcha' data-sitekey={siteKey} />
}

export default Recaptcha;
